import React, { useEffect, useRef, useState } from "react";
import { FaBell } from "react-icons/fa";
import {
  Navbar,
  Container,
  NavbarBrand,
  Button,
  Modal,
  ModalBody,
} from "reactstrap";
import Logo from "../../assets/img/custom/logo.png";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "store/actions/authActions";
import { CSVLink } from "react-csv";
import moment from "moment";
import { getSurvey } from "store/actions/surveyAction";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { getUnreadNotificationsCount } from "store/actions/notificationAction";
const AdminNavbar = (props) => {
  const dispatch = useDispatch();
  const history = useHistory();

  const survey = useSelector((state) => state.survey.surveyData);
  const { unreadNotificationsCount } = useSelector(
    (state) => state.notifications
  );

  const [logoutModal, setLogoutModal] = useState(false);
  const csvLink = useRef(null);

  const logoutToggle = () => {
    setLogoutModal(!logoutModal);
  };
  const headers = [
    { label: "Name", key: "name" },
    { label: "Conference", key: "conference" },
    { label: "Email", key: "email" },
    { label: "Perspective", key: "perspective" },
    { label: "Sport ", key: "sport" },
    { label: "coachBackground", key: "coachBackground" },
    { label: "Type ", key: "type" },
  ];

  useEffect(() => {
    dispatch(getSurvey());
    dispatch(getUnreadNotificationsCount());
  }, []);

  return (
    <>
      <Navbar
        className="navbar-top bg-white d-none d-md-flex"
        expand="md"
        id="navbar-main"
      >
        <NavbarBrand
          className="pt-0"
          href="https://fans-help-players-athlete.web.app/"
        >
          <img className="mx-2" alt={Logo} src={Logo} height="70px" />
        </NavbarBrand>

        <Container fluid className="d-flex justify-content-end ">
          <div
            onClick={() => history.push("/admin/notifications")}
            className="position-relative mr-4"
            style={{ cursor: "pointer" }}
          >
            <FaBell size={24} className="text-dark" />
            {unreadNotificationsCount > 0 && (
              <span
                className="position-absolute badge rounded-pill bg-danger"
                style={{
                  fontSize: "0.5rem",
                  color: "white",
                  top: "-10px",
                  right: "-5px",
                  zIndex: 1,
                }}
              >
                {unreadNotificationsCount}
              </span>
            )}
          </div>
          <div>
            <CSVLink
              ref={csvLink}
              headers={headers}
              filename={`Orders ${moment(new Date()).format("DD-MM-YYYY")}.csv`}
              data={
                survey == -1
                  ? []
                  : survey.map((item) => {
                      return {
                        ...item,
                      };
                    })
              }
              className="ml-auto btn btn-primary mr-2"
            >
              Export Survey
            </CSVLink>
            <Button className=" bg-transparent border-0" onClick={logoutToggle}>
              Logout
            </Button>
          </div>
        </Container>
      </Navbar>
      <Modal isOpen={logoutModal} centered toggle={logoutToggle}>
        <ModalBody>
          <div className="text-center">
            <i
              className="fa fa-sign-out-alt text-primary"
              style={{ fontSize: 70 }}
            ></i>
            <br />
            <br />
            <span className="mt-5" style={{ fontSize: 30 }}>
              Are you sure?
            </span>
            <br />
            <br />
            <span className="mt-5" style={{ fontSize: 16 }}>
              You want to logout.
            </span>
            <br />
            <br />
            <br />
            <Button color="secondary" onClick={logoutToggle}>
              Cancel
            </Button>{" "}
            <Button color="primary" onClick={() => dispatch(logout())}>
              Logout
            </Button>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};

export default AdminNavbar;
